import { createListenerMiddleware } from '@reduxjs/toolkit';
import constant from '~/constant';
import createListenerEffect from '~/createListenerEffect';
import { setOffline } from '~/redux/slice';

export const effect = createListenerEffect(
  'common/setOffline<Listener>',
  async (action, { dispatch, getState, unsubscribe, trigger }) => {
    unsubscribe();

    const offline = () => {
      dispatch(setOffline({ trigger }));
    };

    window.addEventListener('offline', offline);
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: constant(true),
  effect,
});

export default middleware;
